<ng-container *ngIf="entity">
  <div class="table mt-0100"
       *ngIf="entity.entityType.languageEnabled">
    <div class="tr tr--noGutter tile__heading pt-0 pb-0">
      <ng-container>Languages</ng-container>
      <ng-container *ngIf="showTaskDoneMark">
        <span class="color--gray ml-0050">
          &bull;
          <span class="color--green">
            <span class="d-none d-inline--md uppercase ml-0025">Done</span>
            <i class="far fa-check ml-0025"></i>
          </span>
        </span>
      </ng-container>
      <button *ngIf="!readonly"
              mat-button
              disableRipple
              class="addNew ml-auto mat-button--no-focus-overlay"
              type="button"
              aria-label="Edit Language"
              (click)="openEditLanguageDialog()">
        <i class="far fa-pencil addNew__icon"></i>
        EDIT
      </button>
    </div>
    <div class="tr tr--noGutter pt-0025">
      <div class="tc tc--80">
        <div class="row row--left fb--baseline recap w-100">
          <div class="recap__label">Preferred</div>
          <div class="recap__value">
            <ng-container *ngFor="let language of entity.entityLanguages">
              <ng-container *ngIf="language.preferred">{{language.languageCode | languageName}}</ng-container>
            </ng-container>
          </div>
          <div class="recap__label">Spoken</div>
          <div class="recap__value">{{ entityLanguagesAsString() }}</div>

        </div>
      </div>
    </div>
  </div>
</ng-container>
